import * as React from "react";
import Logo from "../../res/images/logo.png";
import NavBar from "../navbar/NavBar";
import {Link} from "react-router-dom";
import {ROUTE_HOME} from "../../routing/Routes";
import {AppIcon, ContactInfo} from "../../Config";
import {default as LinkOpen} from "../../modules/Link";
import LocalStorageManager, {LANGUAGE_ID, Languages} from "./LocalStorageManager";
import {FormattedMessage} from "react-intl";

interface Props {
    currentRoute: string,
}

interface State {
    headerClassName: string,
    facebookClassName: string,
}

const SCROLL_SIZE = 50;

export default class Header extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);
        this.state = {
            headerClassName: '',
            facebookClassName: '',
        };
    }

    public componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    public componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    public render(): React.ReactNode {
        const {currentRoute} = this.props;
        const {headerClassName, facebookClassName} = this.state;

        return (
            <>
                <header id={'header'}
                        className={headerClassName}>

                    <div className={"content"}>

                        <Link to={ROUTE_HOME}>
                            <img src={Logo}
                                 alt={'logo'}
                                 className={'image-logo'}
                            />
                        </Link>


                        <div className={'nav-container'}>
                            <NavBar currentRoute={currentRoute}/>
                        </div>

                        {this.renderLanguageSelector()}

                        <div className={`contact-item ${facebookClassName}`}
                             onClick={() => LinkOpen.onWindowOpen(ContactInfo.FACEBOOK)}
                        >
                            <div className={`${AppIcon.FACEBOOK} icon-title`}/>
                        </div>

                    </div>

                </header>
            </>
        )
    }

    private onChangeLanguage = (lang: LANGUAGE_ID): void => {
        LocalStorageManager.setLanguage(lang);
        window.location.reload();
    }

    private renderLanguageSelector(): React.ReactNode {
        const defaultSelected = LocalStorageManager.getLanguage();

        return (
            <div className="language-selector">
                <select name={'language'}
                        id={"language"}
                        value={defaultSelected as string}
                        onChange={(event) => this.onChangeLanguage(event.target.value as LANGUAGE_ID)}
                >
                    <FormattedMessage id={'language.es'}>
                        {(message) => <option value={Languages.ES}>{message}</option>}
                    </FormattedMessage>

                    <FormattedMessage id={'language.ca'}>
                        {(message) => <option value={Languages.CA}>{message}</option>}
                    </FormattedMessage>

                    <FormattedMessage id={'language.en'}>
                        {(message) => <option value={Languages.EN}>{message}</option>}
                    </FormattedMessage>

                </select>
            </div>
        )
    }

    private setHeaderBigClassName = (): void => {
        this.setState({headerClassName: '', facebookClassName: ''})
    }

    private setHeaderSmallClassName = (): void => {
        this.setState({headerClassName: 'small-header', facebookClassName: 'up-header'})
    }

    private handleScroll = (): void => {
        const headerElement = document.getElementById('header');
        if (headerElement) {
            if (document.body.scrollTop > SCROLL_SIZE || document.documentElement.scrollTop > SCROLL_SIZE) {
                this.setHeaderSmallClassName();
            } else {
                this.setHeaderBigClassName();
            }
        }
    }
}